
(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    // Quantity steppers live in theme.js (cart drawer + cart page); avoid duplicate handlers here.

    var KEY = "pesco_wishlist";
    function readWish() {
      try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
    }
    function writeWish(items) { localStorage.setItem(KEY, JSON.stringify(items)); }
    document.querySelectorAll(".js-wishlist").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        var handle = el.getAttribute("data-product-handle");
        if (!handle) return;
        var items = readWish();
        if (items.indexOf(handle) === -1) items.push(handle);
        writeWish(items);
      });
    });

    var productJsonEl = document.querySelector('[id^="ProductJson-"]');
    var variantInput = document.querySelector(".js-variant-id");
    if (productJsonEl && variantInput) {
      try {
        var productData = JSON.parse(productJsonEl.textContent);
        var optionSelects = Array.prototype.slice.call(document.querySelectorAll(".js-product-option"));
        function selectedOptions() {
          return optionSelects.map(function (select) { return select.value; });
        }
        function matchVariant() {
          var selected = selectedOptions();
          return (productData.variants || []).find(function (variant) {
            return variant.options.every(function (option, index) { return option === selected[index]; });
          });
        }
        function syncVariant() {
          var variant = matchVariant();
          if (!variant) return;
          variantInput.value = variant.id;
          var submit = document.querySelector("#product-form .theme-btn");
          if (submit) {
            submit.disabled = !variant.available;
            submit.textContent = variant.available ? "Add To cart" : "Sold out";
          }
        }
        optionSelects.forEach(function (select) {
          select.addEventListener("change", syncVariant);
        });
      } catch (e) {}
    }
  });
})();
